function initGoogleMap() {

    function forEach(array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]);
        } 
    }

    var maps = document.getElementsByClassName('gmap'); 
      
    function startMap(map) {

        var data = JSON.parse(map.getAttribute('data-map'));

        var singleElement = map.getAttribute('data-singlemarker');
        
        if(singleElement){
            var ltd = data[0][0];
            var lng = data[0][1];
        } else {
            var ltd = '45.44047768041298';
            var lng = '12.327867591217254';
        }
          
        var map = new google.maps.Map(map, {
            zoom: 17,
            center: new google.maps.LatLng(ltd, lng),
            mapTypeId: 'terrain',
        });
        
        var markerImage = {
            url: baseUrl + '/assets/images/marker.svg',
            size: new google.maps.Size(50, 65),
            origin: new google.maps.Point(0, 0)
        }

        var marker, i;
    
        for (i = 0; i < data.length; i++) { 
            
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(data[i][0], data[i][1]),
                map: map,
                icon: markerImage                        
            });
            
            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    window.open(data[i][2]);
                }
            })(marker, i));

        }


    }

    if (maps) {
        forEach(maps, function (index, map) {
            startMap(map);
        });
    }

}